import Welcome from './Welcome'
import Form from './Form'
import FormSimple from './FormSimple'
import Loader from './Loader'
import Thanks from './Thanks'
import Landing from './Landing'
import Quiz from './Quiz'

export default {
  Welcome,
  Form,
  FormSimple,
  Loader,
  Thanks,
  Landing,
  Quiz,
}
